import { render, staticRenderFns } from "./CopyRevisionModal.vue?vue&type=template&id=0b63a9b8"
import script from "./CopyRevisionModal.vue?vue&type=script&lang=js"
export * from "./CopyRevisionModal.vue?vue&type=script&lang=js"
import style0 from "./CopyRevisionModal.vue?vue&type=style&index=0&id=0b63a9b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports